import axiosInstance from "../axios/axiosInstance";

export interface Flag {
  key: string;
  enabled: boolean;
  category: string;
}

export const getFlags = async (): Promise<Record<string, Flag>> => {
  try {
    const response = await axiosInstance.get(`/flag/active`);
    return response.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};
